import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { LoginGuardService } from '../../api/login-guard.service';
import { IAccountType } from '../../constants/account-types';



@Component({
  selector: 'view-pending-accomm',
  templateUrl: './view-pending-accomm.component.html',
  styleUrls: ['./view-pending-accomm.component.scss']
})
export class ViewPendingAccommComponent implements OnInit {

  public breadcrumb = [];

  constructor(
    private loginGuard: LoginGuardService, // 
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
  ) { }
  
  ngOnInit() {
    this.loginGuard.activate([IAccountType.TEST_ADMIN]);
    window.scrollTo(0,0);
    this.breadcrumb = [
      this.breadcrumbsService.TESTADMIN_LANDING(),
      this.breadcrumbsService.TESTADMIN_DASHBOARD(),
      this.breadcrumbsService._CURRENT('--', this.router.url),
    ];
  }
}
